import React from 'react'
import './index.less'
import Overlay from './../../share/Overlay/index'
import bandCardDialogImg from './../../../assets/images/bandCardDialog.png'
class BandCardStatusDialog extends React.Component {
    render () {
        const { confirmText, handleShowDialog, tobind, isBtn } = this.props
        return (
            <React.Fragment>
                <Overlay />
                <div className={'bandCardStatusContainer'} >
                    <div className={'bandCardImgContainer'}>
                        <img src={bandCardDialogImg} alt="" />
                    </div>
                    <p className={'bandCardText'}>
                        {confirmText}
                    </p>
                    {
                        isBtn && (
                            <div
                                className={'bandCardButton statistics-dom'}
                                onClick={() => tobind()}
                            >立即绑定</div>
                        )
                    }

                    <p
                        className='closeDialog statistics-dom'
                        onClick={handleShowDialog}
                    >
                        取消
                    </p>
                </div>
            </React.Fragment>

        )
    }
}

export default BandCardStatusDialog
